import z from 'zod';

const getOptionWithCountSchema = z
  .object({ label: z.string(), value: z.string(), taggedCount: z.number() })
  .transform((obj) => obj.taggedCount);

export const getCountFromData = (data: unknown): number | undefined => {
  try {
    return getOptionWithCountSchema.parse(data);
  } catch (error) {
    return undefined;
  }
};
